import moment from 'moment';

export const adjustEndTime = (
  onChangeTime: moment.MomentInput,
  duration: moment.DurationInputArg1
): string => {
  const newStartMoment = moment(onChangeTime, 'HHmm');
  newStartMoment.add(duration, 'minutes');
  const newEndTime = newStartMoment.format('HHmm');

  return newEndTime;
};

export const adjustEndDate = (startDate: Date, duration: number): Date => {
  const adjustedEndDate = moment(startDate).add(duration, 'days').toDate();

  return adjustedEndDate;
};
